<ion-footer no-border>
	<div *ngIf="isInSideMenu" class="side-menu-wrapper">
		<img src="assets/imgs/logo_milktracker.png" class="logo" />
		<p class="app-info">version {{version}}</p>
		<a class="app-hash" (click)="copyCommitHash()">{{commit}}</a>
	</div>
</ion-footer>
